export default __webpack_public_path__ + "static/media/tuskers-logo.cc203d0c.jpg";